import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { StatusPill } from '@lyearn/ui';
import { EventStatusEnum } from '@/types/schema';

import { useLearningContent } from '../context';
import { EventStatusProps } from '../types';

function EventStatus({ className = 'flex-shrink-0' }: EventStatusProps) {
  const { t } = useTranslation();
  const { content } = useLearningContent();
  const status = content.event?.status;

  if (status !== EventStatusEnum.Completed) {
    return null;
  }

  return (
    <StatusPill
      appearance="secondary"
      className={className}
      label={t('Common:Filter.Finished')}
      size="medium"
      variant="light"
    />
  );
}

export default React.memo(EventStatus);
